export default __webpack_public_path__ + "static/media/q.1e5d7b43.svg";